<template>
    <div class="bg-white pd-5 un-select" v-show="menu_opens.length > 0">
        <Tag type="dot" :name="index" closable :color="item.curr == 1?'success':''" :checkable="true"
             v-for="(item,index) in menu_opens" :key="index" @on-change='onChange' @on-close="onClose">{{item.fn}}</Tag>
    </div>
</template>

<script>
    export default {
        name: "myMenuOpens",
        props:{
            fixed: {
                default: true,
                type: Boolean,
            }
        },
        computed:{
            menu_opens () {
                return this.$store.state.baseData.menu_opens;
            }
        },
        methods: {
            onChange(checked,index){
                this.$base.linkTo(this.menu_opens[index].url);
            },
            onClose(event,index){
                this.$store.dispatch("delBaseData_MenuOpens",index);
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myMenuOpens.vue